import { useState } from "react";
import { useSetPageTitle } from "../../hooks/useSetPageTitle";
import PacingTab from "./tabs/pacing-tab";
import AnalysisTab from "./tabs/analysis-tab";
import OverviewTab from "./tabs/overview-tab";
import { AppLayout } from "../../components/layout/app-layout";

// TODO: Remove this once we have a new layout for client users
// import { useIsMobile } from "../../hooks/useMobile";
// import { SidebarProvider, SidebarTrigger } from "../../components/ui/sidebar";
// import DashboardSidebar from "../dashboard/components/dashboard-sidebar";
// import { DashboardMenubar } from "src/components/menubar/menubar";
// import { useNavigate } from "react-router-dom";
// import { ReactComponent as BackArrow } from 'src/assets/icons-redesign/back-arrow.svg';
// import { shouldUseNewLayout } from "../../helpers/layout.helpers";
// import { useSelector } from "react-redux";
// import { RootState } from "../../redux/redux-store";


const PerformancePage = () => {
  useSetPageTitle('Performance');
  // TODO: Remove this once we have a new layout for client users
  // const { isMobile } = useIsMobile();
  // const navigate = useNavigate();
  // const userState = useSelector((state: RootState) => state.userState);
  // const useNewLayout = shouldUseNewLayout(userState.permissions);
  const [activeTab, setActiveTab] = useState<'overview' | 'pacing' | 'analysis'>('overview');

  const performanceTabs = [
    {
      id: 'overview',
      label: 'Overview',
      onClick: () => setActiveTab('overview'),
    },
    {
      id: 'pacing',
      label: 'Pacing',
      onClick: () => setActiveTab('pacing'),
    },
    {
      id: 'analysis',
      label: 'Analysis',
      onClick: () => setActiveTab('analysis'),
    },
  ];

  // Legacy layout for client users
  // TODO: Remove this once we have a new layout for client users
  // if (!useNewLayout) {
  //   return (
  //     <SidebarProvider>
  //       <DashboardSidebar activePage="/performance" />
  //       <div className="flex flex-col w-full grow p-4 md:p-10 gap-6 h-screen overflow-hidden">
  //         <div className="flex gap-4 items-center flex-shrink-0">
  //           {isMobile && (
  //             <div className="flex size-12 items-center justify-center">
  //               <SidebarTrigger />
  //             </div>
  //           )}
  //           <div
  //             className='bg-white rounded-full shadow-md p-2 cursor-pointer w-[34px] h-[34px] flex items-center justify-center mb-1'
  //             onClick={() => navigate(-1)}
  //           >
  //             <BackArrow className="size-[18px]" />
  //           </div>
  //           <span className="text-3xl mt-2 md:text-5xl md:mt-0">
  //             Performance
  //           </span>
  //           <div className="items-end ml-auto">
  //             <DashboardMenubar />
  //           </div>
  //         </div>
  //         <div className="flex-1 overflow-hidden">
  //           {activeTab === 'pacing' && <PacingTab />}
  //           {activeTab === 'analysis' && <AnalysisTab />}
  //         </div>
  //       </div>
  //     </SidebarProvider>
  //   );
  // }

  // New layout for org admins and regular users
  return (
    <AppLayout
      activePage="/performance"
      navbarProps={{
        showBackButton: true,
        backPath: "/dashboard",
        tabs: performanceTabs,
        activeTab: activeTab,
        onTabChange: (tabId: string) => setActiveTab(tabId as 'overview' | 'pacing' | 'analysis'),
      }}
    >
      <div className="h-[calc(100vh-8rem)]">
        {activeTab === 'overview' && <OverviewTab />}
        {activeTab === 'pacing' && <PacingTab />}
        {activeTab === 'analysis' && <AnalysisTab />}
      </div>
    </AppLayout>
  );
};

export default PerformancePage;